module.exports = __webpack_public_path__ + "img/11rm_bg@2x.e24cfa75.png";